import { Component, OnInit, inject } from '@angular/core';

import { TranscriptionLanguagesService } from 'rev-shared/media/transcription/TranscriptionLanguages.Service';
import { orderBy } from 'rev-shared/util/SortUtil';

import { BaseImportDialogComponent } from './BaseImportDialog.Component';
import { ITranscriptSelectionCellRendererParams, TranscriptSelectionCellRendererComponent } from './TranscriptSelectionCellRenderer.Component';
import { IZoomRecording } from './Import.Types';

@Component({
	selector: 'import-zoom-dialog',
	templateUrl: './ImportZoomDialog.Component.html',
	standalone: false
})
export class ImportZoomDialogComponent extends BaseImportDialogComponent implements OnInit {
	public readonly TranscriptionLanguagesService = inject(TranscriptionLanguagesService);
	public readonly transcriptionLanguages = this.TranscriptionLanguagesService.aiServiceLanguages;
	public readonly transcriptSelectionCellRendererParams: ITranscriptSelectionCellRendererParams = {
		getTranscriptionLanguages: () => this.transcriptionLanguages
	};

	public errorGeneric: boolean = false;
	public errorEmailNotFound: boolean = false;
	public zoomRecordings: IZoomRecording[];
	public gridComponents: { [p: string]: any; } = {};

	public import(): void {
		this.isLoading = true;
		this.getSelectedImports().forEach(selectedImport =>
			this.ImportExternalMediaService.importZoomRecording(
				selectedImport.id,
				selectedImport.recordingName,
				selectedImport.recordingFileUrl,
				selectedImport.fileType,
				selectedImport.vttFileUrl,
				selectedImport.vttLanguageCode
			)
		);
		this.closeDialog();
	}

	public areSelectedRowsValid(): boolean {
		return this.getSelectedImports()?.length && this.getSelectedImports().every(recording => {
			return recording.hasVtt ? !!recording.vttLanguageCode : true;
		});
	}

	public fetchRecordings(): Promise<IZoomRecording[]> {
		return this.ImportExternalMediaService.getZoomRecordings();
	}

	public processRecordings(recordings: IZoomRecording[]): void {
		this.zoomRecordings = orderBy(recordings, item => item.creationDate, false).map(item => ({
			...item,
			isSelected: false
		}));
	}

	public handleError(error: any): void {
		if (error.error.code === 'EmailNotFound') {
			this.errorEmailNotFound = true;
		} else {
			this.errorGeneric = true;
		}
	}

	public clearErrors(): void {
		this.errorGeneric = false;
		this.errorEmailNotFound = false;
	}

	public assignDataGridSettings(): void {
		super.assignGridDefaultColDef();
		super.assignGridOptions();
		this.assignGridComponents();
		this.assignGridColumnDefs();
	}

	public assignGridColumnDefs(): void {
		this.gridColumnDefs = [
			...this.getCommonColumnDefs('recordingName', 'creationDate', 'size'),
			{
				field: 'hasVtt',
				headerName: this.TranslateService.instant('Transcript'),
				sortable: true,
				tooltipValueGetter: data => !data.value ? this.TranslateService.instant('None') : this.TranslateService.instant('SelectLanguage'),
				cellRenderer: 'transcriptSelection',
				cellRendererParams: this.transcriptSelectionCellRendererParams,
				minWidth: 250
			}
		];
	}

	public assignGridComponents(): void {
		this.gridComponents = {
			transcriptSelection: TranscriptSelectionCellRendererComponent
		};
	}

}
